var _g, _g2, _rect, _path, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 224,
    viewBox: "0 0 456 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1451_65088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.9043,
    y: 131.941,
    width: 447.988,
    height: 62.6922,
    rx: 5.22435,
    transform: "rotate(3.76262 8.9043 131.941)",
    fill: "#F2E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7961 173.302L50.7371 174.198C50.6746 175.149 50.2371 176.035 49.5207 176.663C48.8044 177.291 47.868 177.609 46.9174 177.546C45.9669 177.484 45.0801 177.046 44.4522 176.33C43.8243 175.614 43.5066 174.677 43.5691 173.727L43.6281 172.831M56.9461 171.875C55.6238 170.02 54.6674 169.057 54.9865 164.205C55.2787 159.761 53.1137 158.029 51.2967 157.137C51.0553 157.019 50.8372 156.77 50.7784 156.51C50.5241 155.373 49.6703 154.331 48.4495 154.25C47.2287 154.17 46.2451 155.092 45.8475 156.187C45.755 156.439 45.5063 156.654 45.2515 156.74C43.331 157.387 40.9604 158.815 40.6679 163.263C40.346 168.115 39.2718 168.945 37.7179 170.61C37.0742 171.3 37.5241 172.429 38.5662 172.498L55.8635 173.635C56.9001 173.703 57.4908 172.639 56.9461 171.875Z",
    stroke: "#E2A6B0",
    strokeWidth: 1.79587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7119,
    y: 154.207,
    width: 112.871,
    height: 13.5137,
    rx: 2.61217,
    transform: "rotate(3.76262 75.7119 154.207)",
    fill: "#E9C9CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.4824,
    y: 172.902,
    width: 362.408,
    height: 13.5137,
    rx: 2.61217,
    transform: "rotate(3.76262 74.4824 172.902)",
    fill: "#E5C2C8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1451_65088)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 447.988,
    height: 62.6922,
    rx: 5.22435,
    transform: "matrix(-0.997845 0.0656229 0.0656229 0.997845 451.813 0.765625)",
    fill: "#C1E6C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.921 42.134L409.98 43.03C410.043 43.9806 410.48 44.8673 411.197 45.4953C411.913 46.1232 412.849 46.4409 413.8 46.3783C414.75 46.3158 415.637 45.8783 416.265 45.1619C416.893 44.4456 417.211 43.5092 417.148 42.5586L417.089 41.6626M403.771 40.7067C405.094 38.852 406.05 37.8893 405.731 33.0369C405.439 28.5933 407.604 26.8609 409.421 25.9692C409.662 25.851 409.88 25.6016 409.939 25.3418C410.193 24.2053 411.047 23.1626 412.268 23.0824C413.489 23.0021 414.472 23.9244 414.87 25.0186C414.962 25.2713 415.211 25.4861 415.466 25.5717C417.386 26.2187 419.757 27.6471 420.049 32.0952C420.371 36.9474 421.446 37.7767 422.999 39.4422C423.643 40.1321 423.193 41.2612 422.151 41.3298L404.854 42.4673C403.817 42.5355 403.226 41.4714 403.771 40.7067Z",
    stroke: "#F9F9F9",
    strokeWidth: 1.79587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112.871,
    height: 13.5137,
    rx: 2.61217,
    transform: "matrix(-0.997845 0.0656229 0.0656229 0.997845 385.005 23.0352)",
    fill: "#CFF3CF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 362.408,
    height: 13.5137,
    rx: 2.61217,
    transform: "matrix(-0.997845 0.0656229 0.0656229 0.997845 386.236 41.7344)",
    fill: "#D7F3D6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0439453,
    y: 100.84,
    width: 447.988,
    height: 62.6922,
    rx: 5.22435,
    transform: "rotate(-5.05374 0.0439453 100.84)",
    fill: "#D4E2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7811 135.307L47.8602 136.201C47.9441 137.15 47.6476 138.094 47.036 138.824C46.4244 139.554 45.5477 140.012 44.5988 140.096C43.6499 140.18 42.7066 139.883 41.9763 139.271C41.246 138.66 40.7885 137.783 40.7046 136.834L40.6255 135.94M53.6397 132.954C52.0487 131.324 50.9561 130.519 50.5277 125.675C50.1354 121.239 47.7305 119.859 45.7983 119.256C45.5416 119.177 45.2878 118.964 45.1899 118.716C44.7644 117.632 43.7609 116.732 42.5422 116.84C41.3236 116.948 40.4929 118.01 40.2677 119.152C40.215 119.416 40.0022 119.666 39.7636 119.79C37.965 120.724 35.8413 122.499 36.234 126.939C36.6595 131.783 35.7251 132.767 34.4449 134.651C33.9145 135.432 34.5321 136.479 35.5725 136.387L52.8397 134.86C53.8745 134.768 54.2952 133.626 53.6397 132.954Z",
    stroke: "#A9C6F0",
    strokeWidth: 1.79587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.4741,
    y: 112.602,
    width: 112.871,
    height: 13.5137,
    rx: 2.61217,
    transform: "rotate(-5.05374 69.4741 112.602)",
    fill: "#F0F6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1255,
    y: 131.273,
    width: 362.408,
    height: 13.5137,
    rx: 2.61217,
    transform: "rotate(-5.05374 71.1255 131.273)",
    fill: "#EBF1FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1451_65088"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.9043,
    y: 131.941,
    width: 447.988,
    height: 62.6922,
    rx: 5.22435,
    transform: "rotate(3.76262 8.9043 131.941)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1451_65088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 447.988,
    height: 62.6922,
    rx: 5.22435,
    transform: "matrix(-0.997845 0.0656229 0.0656229 0.997845 451.813 0.765625)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.aac59827d7bfb134dc0bef51d5278e3e.svg";
export { ForwardRef as ReactComponent };